
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Question } from '@/utils/personalityTypes';

interface QuestionCardProps {
  currentQuestion: Question;
  currentQuestionIndex: number;
  questionsLength: number;
  isTransitioning: boolean;
  handleAnswer: (questionId: number, value: number) => void;
}

const QuestionCard = ({ 
  currentQuestion, 
  currentQuestionIndex, 
  questionsLength,
  isTransitioning,
  handleAnswer 
}: QuestionCardProps) => {
  
  const getAnswerButtonClass = (value: number) => {
    let baseClasses = "w-full justify-start h-auto py-3 px-4 rounded-lg mt-2 text-left transition-all duration-300";
    
    switch (value) {
      case 2:
        return cn(baseClasses, "hover:bg-emerald-50 hover:border-emerald-400 hover:text-emerald-700");
      case 1:
        return cn(baseClasses, "hover:bg-green-50 hover:border-green-400 hover:text-green-700");
      case 0:
        return cn(baseClasses, "hover:bg-blue-50 hover:border-blue-400 hover:text-blue-700");
      case -1:
        return cn(baseClasses, "hover:bg-amber-50 hover:border-amber-400 hover:text-amber-700");
      case -2:
        return cn(baseClasses, "hover:bg-red-50 hover:border-red-400 hover:text-red-700");
      default:
        return baseClasses;
    }
  };
  
  const renderAnswerOption = (value: number, label: string, question: Question) => (
    <Button
      key={value}
      onClick={() => handleAnswer(question.id, value)}
      variant="outline"
      className={getAnswerButtonClass(value)}
    >
      {label}
    </Button>
  );

  return (
    <div 
      className={cn(
        "transition-all duration-300",
        isTransitioning ? "opacity-0 transform translate-y-4" : "opacity-100 transform translate-y-0"
      )}
    >
      <div className="glass-card rounded-xl p-6 shadow-soft border border-white/20 animate-scale-in">
        <h3 className="text-xl font-medium mb-4 text-secondary flex items-center">
          <span className="bg-secondary/10 text-secondary h-8 w-8 rounded-full inline-flex items-center justify-center mr-2 text-sm font-bold">
            {currentQuestionIndex + 1}
          </span>
          <span>of {questionsLength}</span>
        </h3>
        <p className="text-lg mb-6 font-medium">{currentQuestion.text}</p>
        
        <div className="space-y-2">
          {renderAnswerOption(2, "Strongly Agree", currentQuestion)}
          {renderAnswerOption(1, "Somewhat Agree", currentQuestion)}
          {renderAnswerOption(0, "Neutral", currentQuestion)}
          {renderAnswerOption(-1, "Somewhat Disagree", currentQuestion)}
          {renderAnswerOption(-2, "Strongly Disagree", currentQuestion)}
        </div>
      </div>
    </div>
  );
};

export default QuestionCard;
